'use client';

import _logger from '@lib/logger';
import {Configuration, PublicApi} from '@linx-security/api-specs';
import {getCastErrorMiddleware, getLogMiddleware, getSessionMiddleware, queryParamsStringify} from '@linx-security/api';
import {signOut} from 'next-auth/react';
import {useRef} from 'react';

import {ConsoleApi} from '../../(admin)/_lib/ConsoleApi';
import {routes} from '../../_lib/browser/api-routes';

export const logger = _logger.child?.({module: `api`}, {});
/**
 * Those hooks are used to retrieve the api client on the client side and perform requests.
 * Due to legacy reasons we hold ConsoleApi which extends PublicApi therefore it's a bit of duplication.
 * Ideally (once manifests API is in the BE) we wont need to to have this extension and ConsoleApi will be used
 * Only for "real" console use cases where the FE has it's own API.
 */

/**
 * @description React hook that returns the client instance for the Console API, since it's a stateless object, we can use a ref to keep it, as long as the component is mounted.
 * We can consider moving this to a context if we need to share the client instance across the app.
 * @returns The client instance
 */
export const useApiClient = () => {
  const client = useRef<ConsoleApi>(getClient());
  return client.current;
};

/**
 * @description React hook that returns the client instance for the Linx BE API, since it's a stateless object, we can use a ref to keep it, as long as the component is mounted.
 * We can consider moving this to a context if we need to share the client instance across the app.
 * @returns The client instance
 */
export const useBEApiClient = () => {
  const client = useRef<PublicApi>(new PublicApi(DEFAULT_CONFIG));
  return client.current;
};
const DEFAULT_CONFIG = new Configuration({
  basePath: routes.baseURL,
  queryParamsStringify,
  middleware: [getLogMiddleware(logger), getSessionMiddleware(logger, () => signOut()), getCastErrorMiddleware(logger)],
});

export const getClient = (config: Configuration = DEFAULT_CONFIG) => {
  const client = new ConsoleApi(config);
  return client;
};

export const getApiClient = (config: Configuration = DEFAULT_CONFIG) => {
  const client = new PublicApi(config);
  return client;
};
